module.exports = __webpack_public_path__ + "media/flags/ar-56f01add.svg";